import React from "react";
import { BusFront, ShieldCheck, Clock3, UsersRound } from "lucide-react";

import bus from "../../../assets/blogs/express.png";

const ExpressAbout = () => {
  const brandPurple = "#bd06b3";
  const brandBlue = "#00bfff";

  const values = [
    {
      icon: ShieldCheck,
      title: "Safety First",
      description:
        "Passenger safety is our highest priority across every journey and service.",
    },
    {
      icon: Clock3,
      title: "Reliable Service",
      description:
        "We focus on timely schedules and dependable transportation services.",
    },
    {
      icon: UsersRound,
      title: "Customer Focus",
      description:
        "We work to provide a comfortable and convenient experience for every passenger.",
    },
  ];

  const stats = [
    {
      value: "2000+",
      label: "Tickets Booked Daily",
    },
    {
      value: "500+",
      label: "Buses & Routes",
    },
    {
      value: "30+",
      label: "Districts Covered",
    },
    {
      value: "1M+",
      label: "Passengers Served",
    },
  ];

  return (
    <section
      style={{
        padding: "60px 20px",
        backgroundColor: "#ffffff",
        fontFamily: "sans-serif",
        marginTop: "-50px",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* ================= HERO / ABOUT ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            alignItems: "center",
            gap: "50px",
            marginBottom: "70px",
          }}
        >
          {/* Content */}
          <div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "15px",
                color: brandPurple,
                fontSize: "12px",
                fontWeight: "700",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              <BusFront size={16} />
              Iconic Express
            </div>

            <h2
              style={{
                margin: "0 0 18px",
                fontSize: "clamp(30px, 4vw, 42px)",
                lineHeight: "1.2",
                fontWeight: "800",
                color: "#1e293b",
              }}
            >
              Moving People,
              <br />
              <span style={{ color: brandPurple }}>Connecting Lives</span>
            </h2>

            <div
              style={{
                width: "55px",
                height: "3px",
                backgroundColor: brandBlue,
                marginBottom: "22px",
              }}
            />

            <p
              style={{
                margin: "0 0 15px",
                color: "#64748b",
                fontSize: "15px",
                lineHeight: "1.8",
              }}
            >
              Iconic Express Ltd. is a transportation and bus service company
              focused on providing safe, comfortable and dependable passenger
              transportation services.
            </p>

            <p
              style={{
                margin: 0,
                color: "#64748b",
                fontSize: "15px",
                lineHeight: "1.8",
              }}
            >
              Through convenient ticketing, scheduled routes and
              customer-focused services, Iconic Express aims to make intercity
              travel easier and more accessible.
            </p>
          </div>

          {/* Image */}
          <div>
            <div
              style={{
                position: "relative",
                padding: "10px",
                border: `1px solid ${brandPurple}25`,
                borderRadius: "16px",
                backgroundColor: "#ffffff",
              }}
            >
              <img
                src={bus}
                alt="Iconic Express Bus"
                style={{
                  display: "block",
                  width: "100%",
                  height: "360px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  left: "25px",
                  bottom: "25px",
                  padding: "10px 16px",
                  backgroundColor: "#ffffff",
                  borderLeft: `3px solid ${brandPurple}`,
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                }}
              >
                <span
                  style={{
                    display: "block",
                    color: brandPurple,
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  ICONIC EXPRESS
                </span>

                <span
                  style={{
                    display: "block",
                    marginTop: "3px",
                    color: "#64748b",
                    fontSize: "11px",
                  }}
                >
                  Reliable Passenger Transportation
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ================= CORE VALUES ================= */}
        <div style={{ marginBottom: "60px" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: "35px",
            }}
          >
            <h3
              style={{
                margin: "0 0 10px",
                color: "#1e293b",
                fontSize: "28px",
                fontWeight: "800",
              }}
            >
              Our Core Values
            </h3>

            <p
              style={{
                margin: 0,
                color: "#64748b",
                fontSize: "14px",
              }}
            >
              The principles behind our transportation services.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px",
            }}
          >
            {values.map((item, index) => {
              const Icon = item.icon;

              return (
                <div
                  key={item.title}
                  style={{
                    padding: "25px",
                    backgroundColor: "#ffffff",
                    border: `1px solid ${
                      index === 1 ? brandBlue : brandPurple
                    }35`,
                    borderRadius: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "46px",
                      height: "46px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      backgroundColor:
                        index === 1 ? `${brandBlue}12` : `${brandPurple}12`,
                      color: index === 1 ? brandBlue : brandPurple,
                      marginBottom: "18px",
                    }}
                  >
                    <Icon size={23} strokeWidth={1.8} />
                  </div>

                  <h4
                    style={{
                      margin: "0 0 8px",
                      color: "#1e293b",
                      fontSize: "17px",
                      fontWeight: "700",
                    }}
                  >
                    {item.title}
                  </h4>

                  <p
                    style={{
                      margin: 0,
                      color: "#64748b",
                      fontSize: "13px",
                      lineHeight: "1.7",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* ================= STATS ================= */}
        <div
          style={{
            padding: "30px 20px",
            borderTop: `2px solid ${brandPurple}`,
            borderBottom: `1px solid ${brandBlue}40`,
            backgroundColor: "#f8fafc",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "20px",
          }}
        >
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              style={{
                textAlign: "center",
                padding: "10px",
                borderRight:
                  index !== stats.length - 1 ? "1px solid #e2e8f0" : "none",
              }}
            >
              <div
                style={{
                  color: index % 2 === 0 ? brandPurple : brandBlue,
                  fontSize: "26px",
                  fontWeight: "800",
                  marginBottom: "5px",
                }}
              >
                {stat.value}
              </div>

              <p
                style={{
                  margin: 0,
                  color: "#64748b",
                  fontSize: "12px",
                }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpressAbout;
